import { AbstractControl, ValidationErrors } from "@angular/forms";

//Selection Types
export const SINGLE_SELECTION = 1;
export const MULTIPLE_SELECTION = 1;

export class Constants {
  public static readonly MY_PUBLIC_CONSTANT = 10;

  public static readonly VERSION = "1.0";

  public static readonly TAMIL = "ta";
  public static readonly ENGLISH = "en";
  public static readonly SELECTED_LANGUAGE = Constants.TAMIL;

  public static readonly ADMIN = "100";
  public static readonly EDITOR = "100";
  public static readonly CHEIF_SEC = "201";
  public static readonly COUNTRY_SEC = "202";
  public static readonly DISTRICT_SEC = "203";
  public static readonly ZONAL_SEC = "204";
  public static readonly LOKSABHA_SEC = "999";
  public static readonly CONSTITUENCY_SEC = "205";
  public static readonly CIRCLE_SEC = "206";
  public static readonly MEMBER_SEC = "207";
  public static readonly SPONSER = "301";

  // Barracks
  public static readonly BARRACK_PARTY = 1;

  //HIDE OPTIONS
  public static readonly NONE = 0;
  public static readonly CONTRIBUTIONS_ONLY = 1;
  public static readonly EXPENSE_ONLY = 2;
  public static readonly BOTH = 3;

  //CIRCLE Types
  public static readonly CORPORATION = 89;
  public static readonly MUNICIPAL = 88;
  public static readonly TOWN_PANCHAYAT = 87;
  public static readonly UNION = 86;
  public static readonly TALUK = 90;

  //TEMP Assigned
  public static readonly BOOTHS = 1002;
  public static readonly PANCHAYAT = 1003;
  //PARTY AND PUBLIC POST GROUP ID
  public static readonly COUNTRY_OR_STATE = 1;
  public static readonly ZONE = 2;
  public static readonly DISTRICT = 3;
  public static readonly SUB_DISTRICT = 4;
  public static readonly CONSTITUENCY = 5;
  public static readonly LOKSABHA = 20;

  public static readonly MUNICIPAL_POST = 11;
  public static readonly TOWN_PANCHAYAT_POST = 12;
  public static readonly CORPORATION_POST = 13;
  public static readonly UNION_POST = 6;
  public static readonly RURAL_PANCHAYAT_POST = 7;
  public static readonly VILLAGE_COUNCIL_POST = 18;
  public static readonly DISTRICT_PANCHAYAT_POST = 17;
  public static readonly SECTION = 19;

  // public static readonly UNION = 6;
  // public static readonly PANCHAYAT = 7;
  public static readonly CIRCLE = 8;
  public static readonly BRANCH = 9;
  public static readonly WARD = 10;
  // public static readonly MUNICIPAL = 11;
  // public static readonly TOWN_PANCHAYAT = 12;
  // public static readonly CORPORATION = 13;
  // public static readonly BOOTH = 14;
  // public static readonly MEMBER = 15;
  public static readonly PARTY_LEADERSHIP = 16;
  public static readonly DISTRICT_COUNCIL = 17;
  public static readonly UNION_COUNCIL = 18;

  public static readonly PANCHAYAT_WARD = 117;
  public static readonly UNION_WARD = 118;
  public static readonly DISTRICT_WARD = 119;
  public static readonly MUNICIPAL_WARD = 120;
  public static readonly TOWN_PANCHAYAT_WARD = 121;
  public static readonly CORPORATION_WARD = 122;

  //KATTAMAIPPU
  public static readonly ASSEMBLY = 131;
  public static readonly LE = 132;
  public static readonly LS = 133;

  //MYSQLI ERROR NO
  public static readonly DUPLICATE_ENTRY = 1062;
  public static readonly SUBMITTED = 2124;

  public static readonly ERROR_PANCHAYAT_CONTAINS_WARDS = 202;
  public static readonly ERROR_UNION_CONTAINS_WARDS = 203;
  public static readonly ERROR_UNION_CONTAINS_PANCHAYATS = 204;
  public static readonly ERROR_SECTION_CONTAINS_WARDS = 205;
  public static readonly ERROR_WARD_CONTAINS_BOOTHS = 206;
  public static readonly ERROR_WARD_CONTAINS_PANCHAYATS = 207;
  public static readonly ERROR_WARD_CONTAINS_UNION = 208;
  public static readonly ERROR_UNION_CONTAINS_EVENTS = 209;
  public static readonly ERROR_BRANCH_CONTAINS_BOOTHS = 210;
  public static readonly ERROR_WARD_CONTAINS_BOOTH_OR_BRANCH = 210;

  //PARTICIPANTS TYPE
  public static readonly RESPONSIBILITY = 126; //பொறுப்பாளர்
  public static readonly SPEARHEADED = 127; //முன்னெடுத்தவர்
  public static readonly KALAPPANIYALAR = 128; //களப்பணியாளர்
  public static readonly RESOLUTION_SUPPORTER = 129; //ஆதரிப்பவர்
  public static readonly RESOLUTION_OPPONENT = 130; //எதிர்ப்பவர்

  //Local Structure Options

  public static readonly LS_OPTIONS = [
    {
      title: "Rural Panchayats",
      value: 0x02,
    },
    {
      title: "Village Union Councils",
      value: 0x04,
    },
    {
      title: "District Panchayat Board",
      value: 0x08,
    },
    {
      title: "Municipalities",
      value: 0x10,
    },
    {
      title: "Town Panchayats",
      value: 0x20,
    },
    {
      title: "Corporations",
      value: 0x40,
    },
  ];

  public static readonly colorArray = [
    "#8b0000",
    "#2f4f2f",
    "#a52a2a",
    "#0b2b50",
    "#45164b",
    "#3a1b0f",
    "#5040c0",
    "#c44483",
    "#8b4517 ",
    "#50105a",
    "#0080a0 ",
    "#ff0033",
    "#4b0082",
    "#6d8764",
    "#87794e",
    "#3b3131",
    "#25383c",
    "#a6232c",
    "#037dbb",
  ];

  //LANDING PAGES
  public static readonly CHIEF_SENEGAL_EXECUTIVE = 64; //தலைமை_செங்கள_நிர்வாகி
  public static readonly CONSTITUENCY_SECRETARY = 58; //தொகுதி செயலாளர்
  public static readonly STATE_PROCESSOR_ADMINISTRATOR = 44; //மாநில_செயலி_நிர்வாகி
  public static readonly DISTRICT_PROCESSOR_ADMINISTRATOR = 72; //மாவட்ட செயலாளர்
  public static readonly EXECUTIVE_SECRETARY_OF_PARLIAMENT = 42; //நாடாளுமன்ற_செயலி_நிர்வாகி
  public static readonly ZONE_LP = 35; //மாவட்ட (துணை)
  public static readonly UNION_SECRETARY = 59; //ஒன்றியம்

  //RIGHTS
  public static readonly VIEW_ACCESS = 1;
  public static readonly EDIT_ACCESS = 2;

  //PARTY POST REASONS
  public static readonly CURRENTLY_IN_CHARGE = 98; // தற்போது பொறுப்பில் உள்ளார்
  public static readonly NOT_YET_ACCREDITED = 147; // இன்னும் அங்கீகாரம் பெறவில்லை்

  public static readonly EXTEND_RESPONSIBILITY = 153;

  //Alert Ids
  public static readonly PARTY_PERSONS_ALERT_ID = 1;

  public static readonly ASSEMBLY_STRUCTURE = 24;

  public static readonly EVENTS = 30;

  public static readonly BRANCHES = 99;

  public static readonly ASSEMBLY_STRUCTURE_EDIT = 24;

  //Summary JSONS
  public static readonly summary_files = {
    "Number of events per constituency last month": 1,
    "Number of events per constituency last three month": 2,
    "Number of events per constituency last six month": 3,
    "Number of events per barracks last month": 4,
    "Number of events per barracks last three month": 5,
    "Number of events per barracks last six month": 5,
    "Constituency by booths have more than 20 members": 6,
    "Constituency by booth agents filled": 7,
    "Contacts by constituencies": 8,
    "Contacts by barracks": 9,
    "Contacts by country": 10,
    "Contacts by departments": 11,
  };

  //Meeting checklist
  public static readonly MEETING_CHECKLIST = [
    "முந்தைய மாதத்தில் நடந்த அனைத்து நிகழ்வுகளும் பரிசீலிக்கப்பட்டதா?",
    "முந்தைய மாத வரவு-செலவு, சந்தா விவரங்கள் அனைத்தும் முழு கணக்கு அறிக்கை தாக்கல் செய்யப்பட்டதா?",
    "வரும் மாதத்தில் நடத்த இருக்கும் நிகழ்வுகள் மற்றும் நிதி பங்கீடுகள் திட்டமிடப்பட்டதா?",
    "வரும் மாதத்தின் குறைந்தபட்ச செயல்திட்டங்கள் பற்றி திட்டமிடப்படப்பட்டதா? (உதாரணம்)",
    "வருகைப்பதிவேட்டில் கலந்தாய்வில் கலந்து கொண்டவர்களின் கையொப்பம் வாங்கப்பட்டு “தொகுதி கலந்தாய்வு நிகழ்வு” பதிவேற்றம் செய்யப்பட்டதா?",
    "தீர்மானங்கள் நிறைவேற்றப்பட்டிருந்தால், அந்த தீர்மான நகல் “பொறுப்பாளர் நியமன தீர்மானம்” என்ற நிகழ்வு பகுதியில் பதிவேற்றம் செய்யப்பட்டதா?",
  ];

  //Alert Types
  public static readonly ALL_ALERTS = -1;
  public static readonly WELCOME = 1;
  public static readonly NOTIFICATIONS = 2;
  public static readonly PARTY_POST = 2;
  public static readonly MEMBER = 3;
  public static readonly ALL = 4;
  public static readonly PAGES = 5;

  public static readonly PAGE_NAMES = [
    {
      name: "பொறுப்புகள்",
      value: "partyposts",
    },
    {
      name: "நிகழ்வுகள்",
      value: "events",
    },
    {
      name: "உள்ளாட்சி கட்டமைப்பு",
      value: "localStructure",
    },
    {
      name: "சட்டமன்ற கட்டமைப்பு",
      value: "assemblyStructure",
    },
    {
      name: "தொகுதி உட்பிரிவுகள்",
      value: "openDistrictUnionList",
    },
    {
      name: "வா.சாவடி சேர்க்கும் இடம்",
      value: "addBoothToWard",
    },
    {
      name: "மாநிலம் நுழைவு பக்கம்",
      value: "state_processor_administrator",
    },
    {
      name: "தொகுதி நுழைவு பக்கம்",
      value: "constituency_statistics",
    },
    {
      name: "நாடாளுமன்ற நுழைவு பக்கம்",
      value: "cons_by_loksaba",
    },
    {
      name: "வங்கி கணக்குகள்",
      value: "bank_accounts",
    },
    {
      name: "தொகுதி வா.சாவடிகள்",
      value: "booths_by_const",
    },
    {
      name: "தொகுதி பக்கம்",
      value: "const_page",
    },
  ];

  public static readonly EXCLUDED_NOTIFICATION_PAGES = [
    "dashboard",
    "alerts",
    "new_alerts",
    "edit_alerts",
  ];

  //Login Activity rank
  public static readonly ACTIVITY_RED = 0;
  public static readonly ACTIVITY_YELLOW = 3;
  public static readonly ACTIVITY_GREEN = 5;

  public static readonly ACCEPTED_DOCUMENTS = [
    "txt",
    "TXT",
    "pdf",
    "PDF",
    "png",
    "PNG",
    "jpeg",
    "JPEG",
    "jpg",
    "JPG",
    "xls",
    "xlsx",
    "doc",
    "docx",
  ];

  //Event Subgroup Options
  public static readonly EVENT_OPTION_SHOW_BOTH = 0;
  public static readonly EVENT_OPTION_SHOW_EXPENSE = 1;
  public static readonly EVENT_OPTION_SHOW_CONTRIBUTION = 2;
  public static readonly EVENT_OPTION_SHOW_NONE = 3;

  //
  public static readonly EVENT_MEMBER_NOT_ELIGIBLE = 401;

  //Alert notification bg types
  public static readonly ALERT_TYPE_SUCCESS = 1;
  public static readonly ALERT_TYPE_DANGER = 2;
  public static readonly ALERT_TYPE_WARNING = 3;

  //Months
  public static readonly MONTHS = {
    Jan: "ஜனவரி",
    Feb: "பிப்ரவரி",
    Mar: "மார்ச்",
    Apr: "ஏப்ரல்",
    May: "மே",
    Jun: "ஜூன்",
    Jul: "ஜூலை",
    Aug: "ஆகஸ்ட்",
    Sep: "செப்டம்பர்",
    Oct: "அக்டோபர்",
    Nov: "நவம்பர்",
    Dec: "டிசம்பர்",
  };

  //Events Restrictions
  public static readonly EVENT_HIDE_EXPENSES = 0x1;
  public static readonly EVENT_HIDE_CONTRIBUTION = 0x2;
  public static readonly EVENT_HIDE_SPEAR_HEAD = 0x4;
  public static readonly EVENT_HIDE_FIELD_WORKERS = 0x8;
  public static readonly EVENT_HIDE_RESPONSIBILITIES = 0x10;
  public static readonly EVENT_HIDE_UPLOADS = 0x20;
  public static readonly EVENT_HIDE_DETAILS = 0x40;
  public static readonly EVENT_HIDE_DETAILSONREPORT = 0x80;
  public static readonly EVENT_HIDE_UPLOADSONREPORT = 0x100;
  public static readonly EVENT_HIDE_ONREPORT = 0x200;
  public static readonly EVENT_ONLY_ONCE_IN_MONTH = 0x400;
  public static readonly EVENT_MUST_IN_A_MONTH = 0x800;
  public static readonly EVENT_HIDE_BOOTHS = 0x1000;
  public static readonly EVENT_HIDE_PARTICIPANTS = 0x2000;
  public static readonly HIDE_FROM_COMMON_EVENTS = 0x4000;
  public static readonly EVENT_SHOW_SUPPORTER = 0x8000;
  public static readonly EVENT_SHOW_OPPONENT = 0x10000;

  //Party Post restrictions
  public static readonly PARTY_POST_PAGE_ACCESS = 0x1;
  public static readonly PARTY_POST_ENABLE_EDIT_ACCESS = 0x2;
  public static readonly PARTY_POST_ENABLE_VIEW_ACCESS = 0x4;

  //Election Types
  public static readonly LOKSABHA_ELECTION = 97;
  public static readonly ASSEMBLY_ELECTION = 102;
  public static readonly LOCAL_ELECTION = 96;

  //Election Status
  public static readonly ELECTION_DEFAULT = -1;
  public static readonly ELECTION_CANDIDATE_ENTRY = 108;
  public static readonly ELECTION_CANDIDATE_ENTRY_FINISHED_ELECTION_TO_BE_HELD = 109;
  public static readonly ELECTION_COMPLETED_COUNTING_PROGRESS = 110;
  public static readonly ELECTION_ALL_PROGRESS_COMPLETED = 111;

  //Notes status
  public static readonly NOTE_DELETED = 0;
  public static readonly NOTE_ACTIVE = 1;

  //Ullatchi kattamaipu types
  public static readonly RURAL_PANCHAYATS = 1;
  public static readonly VILLAGE_UNION_COUNCIL = 2;
  public static readonly DISTRICT_PANCHAYAT_BOARD = 3;

  //Messages
  public static readonly ADDED_SUCCESS = "Added successfully.";
  public static readonly UNABLE_TO_ADD = "Unable to add. Please try again.";
  public static readonly DELETED_SUCCESS = "Deleted successfully.";
  public static readonly DELETED_ERROR = "Unable to delete please try again.";
  public static readonly UPDATED_SUCCESS = "Updated successfully.";
  public static readonly UPDATED_ERROR = "Unable to update. Please try again.";
  public static readonly FILL_ALL_DETAILS = "Please fill all details.";
  public static readonly UNABLE_TO_GET_DATA =
    "Unable to get data. Please try again.";

  //Event Type
  public static readonly PORUPALAR_NIYAMANA_THEERMANAM = "70";
  public static readonly THOGUTHI_KALANTHAIVU = "1";
  public static readonly MAADHANTHIRA_SANDHA = "61";
  public static readonly POTHU_VARAVU_SELAVU = "62";

  //Appointment Status
  public static readonly APPOINTMENT_COMING_SOON = 1;
  public static readonly APPOINTMENT_COMPLETED = 0;
  public static readonly APPOINTMENT_IN_PROGRESS = -1;

  //Survey Types
  public static readonly SURVEY_OPTIONAL = 1;
  public static readonly SURVEY_FORCE = 2;

  //Survey Control Types

  public static readonly RADIO_BUTTON = 1;
  public static readonly CHECKBOX = 2;
  public static readonly TEXTAREA = 4;
  public static readonly BUTTON = 5;

  //Event Tabs
  public static readonly EVENT_TABS = {
    EVENTS: 0,
    GENERAL_FINANCE: 1,
    RESOLUTIONS: 2,
  };
  //Event Tabs

  //Post Keys
  public static readonly TREASURER = 6; //பொருளாளர்
  //Post Keys

  public static readonly QUALIFICATION_ID = 1506;
  public static readonly PROFESSION_ID = 1507;
  public static readonly FAMILY_ASSETS_ID = 1508;
  public static readonly TAMILNADU_ID = 1;

  //Party Positions For
  public static readonly PARTY_POSITION_COUNTRY = 1;

  static validAmount(control: AbstractControl): ValidationErrors | null {
    if (parseInt(control.value?.replace(/[₹,]/g, "")) <= 0) {
      return { validAmount: false };
    }

    return null;
  }
  static checkBoxValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value != 1) {
      return { checkBoxValidator: false };
    }

    return null;
  }
}

export interface Contribution {
  amount: number;
  collector: string;
  contact: string;
  contribution_entered_userid: string;
  contributor: string;
  date: string;
  id: number;
  internal_contirbution: number;
  member_id: string;
  paid: number;
  receiptNum: string;
  manual_receipt_no: string;
  updated_on: string;
  receipt_gen: boolean;
  photo_url: string;
  member_name: string;
  sl_no: string;
}

export const BARRACKS = {
  1: 1,
  2: 2,
  3: 4,
  4: 8,
  5: 16,
  6: 32,
  7: 64,
  8: 128,
  9: 256,
  10: 512,
  11: 1024,
  12: 536870912,
  13: 2048,
  14: 4096,
  15: 8192,
  16: 16384,
  17: 32768,
  18: 65536,
  19: 131072,
  20: 262144,
};

export const PUBLIC_POST_GROUP = {
  COUNTRY: 1,
  DISTRICT: 3,
  ZONE: 4,
  CONSTITUENCY: 5,
  UNION: 6,
  PANCHAYAT: 7,
  CIRCLE: 8,
  BRANCH: 9,
  WARD: 10,
  MUNICIPAL: 11,
  TOWN_PANCHAYAT: 12,
  CORPORATION: 13,
  BOOTH: 14,
  MEMBER: 15,
  SECTION: 19,
  LOKSABHA: 20,
  WORLD: 21,
  TEAM: 22,
};

export const PUBLIC_POST_EVENT_MAST = {
  1: 1,
  10: 4096,
  11: 64,
  12: 128,
  13: 256,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 512,
  2: 2,
  20: 1024,
  21: 0,
  22: 0,
  3: 4,
  4: 8,
  5: 16,
  6: 32,
  7: 2048,
  8: 0,
  9: 8192,
};

export const BARACK_NAMES = {
  1: "நாம் தமிழர் கட்சி",
  10: "மீனவர் பாசறை",
  11: "உழவர் பாசறை",
  12: "செயற்களம்",
  13: "வழக்கறிஞர் பாசறை",
  14: "தகவல் தொழில்நுட்ப பாசறை",
  15: "கலை இலக்கியப் பண்பாட்டுப் பாசறை",
  16: "வணிகர் பாசறை",
  17: "தொழிலாளர் பாசறை",
  18: "மருத்துவ பாசறை",
  19: "குருதிக்கொடை பாசறை",
  2: "இளைஞர் பாசறை",
  20: "விளையாட்டுப் பாசறை",
  3: "மாணவர் பாசறை",
  4: "மகளிர் பாசறை",
  5: "கையூட்டு ஒழிப்பு பாசறை",
  6: "சுற்றுச்சூழல் பாசறை",
  7: "தமிழ் மீட்சிப் பாசறை",
  8: "தகவல் தொழில்நுட்ப  பணியாளர் பாசறை",
  9: "வீரத்தமிழர் முன்னணி",
};

export const MEMBER_OPTIONS = [
  {
    id: 1,
    notes: "தேர்தல் பரப்புரை செய்ய தயாரா? ",
  },
  {
    id: 2,
    notes: "வா.சாவடி முகவராக இருக்க தயாரா?",
  },
  {
    id: 3,
    notes: "கட்சி விளம்பரம்/பதாகை உங்க வீட்டு முன் சுவரில் செய்யலாமா?",
  },
  {
    id: 4,
    notes: "தேர்தல் நிதி தர தயாரா?",
  },
  {
    id: 5,
    notes: "கட்சி பொறுப்பு எடுக்க தயாரா?",
  },
  {
    id: 6,
    notes: "தொடர்பு எண் தவறு",
  },
  {
    id: 7,
    notes: "அழைப்பை ஏற்கவில்லை",
  },
  {
    id: 8,
    notes: "வாகனம் இருந்தால் பரப்புரைக்கோ அல்லது பதாகைக் கட்டி உதவ முடியுமா?",
  },
  {
    id: 9,
    notes: "அதிருப்தியில் உள்ளார்?",
  },
  {
    id: 10,
    notes: "கட்சியில் இருந்து வெளியேறிவிட்டார்",
  },
  {
    id: 11,
    notes: "2 முறை ஒரே உறுப்பினர் பதிவு செய்துள்ளார்",
  },
  {
    id: 12,
    notes: "",
  },
];
//Branch Posts Below
// Corporation -> Section -> Ward -> Branch -> Posts
// Union -> Panchayat -> Branch -> Posts
// Municipal -> Section -> Ward -> Branch -> Posts
// Town Panchayat -> Ward -> Branch -> Posts

//Booth Posts Below
// Corporation -> Section -> Ward -> Booth -> Posts
// Union -> Panchayat -> Ward -> Booth -> Posts
// Town Panchayat -> Ward -> Booth -> Posts
// Municipal -> Section -> Ward -> Booth -> Posts

//Dir
export const CANDIDATE_FILES = "election/candidate";
